import { render, staticRenderFns } from "./EditDebateVenuesContainer.vue?vue&type=template&id=363234cc&"
import script from "./EditDebateVenuesContainer.vue?vue&type=script&lang=js&"
export * from "./EditDebateVenuesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports